import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
    // Check for the presence of the admin token
    const adminToken = localStorage.getItem('admin');
    
    // If there is no token, redirect to the login page
    if (!adminToken) {
        return <Navigate to="/" replace />;
    }
    
    // Otherwise, render the protected component
    return children;
};

export default ProtectedRoute;
